// extracted by mini-css-extract-plugin
module.exports = {"footerCopy":"TEb9xec7B1B9nZosA7vnj","footerAction":"_3GeD30cOiKrUstNUV5EaT_"};